var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "select-page-section", class: { retract: _vm.retracted } },
    [
      _c("div", { staticClass: "header-select-page-section" }, [
        _c("div", { staticClass: "chevron" }, [
          _c("i", {
            staticClass: "fa-solid fa-chevron-left",
            on: { click: _vm.toggleStateRetracted },
          }),
        ]),
        _c("h4", [_vm._v(_vm._s(_vm.$t(_vm.titleKey)))]),
      ]),
      _c(
        "div",
        { staticClass: "container-select-page" },
        [
          !_vm.pageLoaded
            ? _c(
                "div",
                { staticClass: "skeleton-loader" },
                _vm._l(10, function (n) {
                  return _c(
                    "div",
                    [
                      _c("VueSkeletonLoader", {
                        attrs: {
                          type: "circle",
                          width: 35,
                          height: 35,
                          animation: "fade",
                          "wave-color": "rgba(255, 255, 255, 0.3)",
                        },
                      }),
                      !_vm.retracted
                        ? _c("VueSkeletonLoader", {
                            attrs: {
                              type: "rect",
                              width: 140,
                              height: 18,
                              rounded: 1,
                              radius: 4,
                              animation: "wave",
                              "wave-color": "rgba(255, 255, 255, 0.3)",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                }),
                0
              )
            : _vm._e(),
          _c("SelectPage", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.pageLoaded,
                expression: "pageLoaded",
              },
            ],
            attrs: {
              id: "selectPageSection",
              groups: _vm.filteredGroups,
              allPages: _vm.filteredAllPages,
              SelectPageProp: _vm.pagesSelected,
              forceOpenAllGroups: _vm.retracted,
              isFreezed: _vm.freeze,
            },
            on: { updateSelectPage: _vm.updateSelectPage },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }